/* eslint-disable */
/* Motor de cálculo de Admin → Inventario → Oferta disponible.
   Recibe los datos de GET admin/oferta-disponible (OfertaDisponibleService)
   y devuelve funciones puras: filtrar, contar, demanda, etc.
   Nada de HTML acá (eso va en odVistas.js / odPais.js).
   Portado tal cual de la demo aprobada (OneDrive\Desktop\oferta-disponible),
   sin "en proceso de publicación". */
export const BASE = '/admin/oferta-disponible';

export function crearMotor(D) {

    // ── Catálogos ────────────────────────────────────────────────────────
    const CAT = [
        { n: 'Habitaciones', d: '1 o 2 huéspedes', corto: 'Habitación' },
        { n: 'Dptos. o casas completos', d: '1 o 2 huéspedes', corto: 'Completo 1–2' },
        { n: 'Otros tipos', d: 'Completos 3+, residencias, compartidos', corto: 'Otro tipo' },
    ];
    const SUB = ['Completo 3+ huéspedes', 'Completo sin capacidad cargada', 'Compartido / residencia / cowork'];
    const TRAMOS = [
        { n: 'Menos de 150 €', a: 0, b: 150 },
        { n: '150 € – 299 €', a: 150, b: 300 },
        { n: '300 € – 450 €', a: 300, b: 451 },
        { n: '451 € – 700 €', a: 451, b: 701 },
        { n: 'Más de 700 €', a: 701, b: Infinity },
        { n: 'Sin precio cargado', a: null, b: null },
    ];
    // Grupos de integración que ve el director (las 3 API van juntas)
    const INTEG = [
        { n: 'API', d: 'Spacest, Homiii y APT: se sincroniza sola', tono: 'api' },
        { n: 'iCal', d: 'Calendario del anfitrión importado cada día', tono: 'ical' },
        { n: 'Manual', d: 'El anfitrión bloquea fechas a mano', tono: 'manual' },
    ];
    const grupoInteg = (i) => (i <= 2 ? 0 : i - 2);
    const CONT = {
        europa: { n: 'Europa', corto: 'Europa' },
        latam: { n: 'Latinoamérica', corto: 'Latam' },
    };
    // Etapas del CRM que cuentan como "integración pendiente" (abiertas)
    const CRM_ABIERTO = ['pendiente', 'contactado', 'reunion-agendada', 'en-negociacion', 'en-proceso-de-integracion'];

    // ── Pre-cálculo por alojamiento ──────────────────────────────────────
    const paisDe = (ci) => D.ciudades[ci][2];
    const contDe = (p) => (D.paises[p] ? D.paises[p].c : 'otro');
    const A = D.a.map((x) => {
        const p = paisDe(x[1]);
        const precios = x[10] || null;
        return {
            id: x[0], ci: x[1], pais: p, cont: contDe(p), cat: x[2], sub: x[3], cap: x[4],
            integ: x[5], grupo: grupoInteg(x[5]), eur: x[6], moneda: x[7], orig: x[8],
            ent: x[9], precios, host: x[11], nombre: x[12], dir: x[13], sync: x[14], categoria: x[15], lib: x[16],
        };
    });
    // Cuánto tiempo SEGUIDO queda libre desde la entrada (días → tramos)
    const ESTADIA = [
        { n: 'Solo 1 mes', d: '30 a 59 días seguidos', a: 30, b: 60 },
        { n: '2 a 3 meses', d: '60 a 119 días', a: 60, b: 120 },
        { n: '4 a 6 meses', d: '120 a 209 días', a: 120, b: 210 },
        { n: '7 a 11 meses', d: '210 a 364 días', a: 210, b: 365 },
        { n: '12 meses o más', d: 'Sin bloqueos en el próximo año', a: 365, b: Infinity },
    ];
    const primerMesDisp = (u) => { for (let m = 0; m < u.ent.length; m++) if (u.ent[m] > 0) return m; return -1; };
    /** Días libres seguidos entrando en el mes m (o en el primer mes posible si m = -1). */
    const libreDe = (u, m) => { const mm = m >= 0 ? m : primerMesDisp(u); return mm < 0 ? 0 : u.lib[mm]; };
    const estadiaDe = (dias) => { for (let i = ESTADIA.length - 1; i >= 0; i--) if (dias >= ESTADIA[i].a) return i; return -1; };
    const mesesTxt = (dias) => (dias >= 365 ? '12 meses o más' : Math.floor(dias / 30) === 1 ? '1 mes' : Math.floor(dias / 30) + ' meses');
    const precioMes = (u, m) => (m >= 0 && u.precios ? u.precios[m] : u.eur);
    const tramoDe = (eur) => {
        if (eur === null || eur === undefined) return 5;
        for (let i = 0; i < 5; i++) if (eur >= TRAMOS[i].a && eur < TRAMOS[i].b) return i;
        return 4;
    };
    const disponible = (u, m) => m < 0 || u.ent[m] > 0;

    // ── Filtros ──────────────────────────────────────────────────────────
    // F = { cont, pais, ciudad (idx|-1), mes (0..6 | -1 = todas las publicadas),
    //       cat:[], tramo:[], grupo:[], q }
    const vacio = (l) => !l || !l.length;
    function pasa(u, F, sin) {
        if (F.cont && u.cont !== F.cont) return false;
        if (F.pais && u.pais !== F.pais) return false;
        if (sin !== 'ciudad' && F.ciudad >= 0 && u.ci !== F.ciudad) return false;
        if (sin !== 'mes' && !disponible(u, F.mes)) return false;
        if (sin !== 'cat' && !vacio(F.cat) && F.cat.indexOf(u.cat) < 0) return false;
        if (sin !== 'grupo' && !vacio(F.grupo) && F.grupo.indexOf(u.grupo) < 0) return false;
        if (sin !== 'tramo' && !vacio(F.tramo) && F.tramo.indexOf(tramoDe(precioMes(u, F.mes))) < 0) return false;
        if (sin !== 'est' && !vacio(F.est) && F.est.indexOf(estadiaDe(libreDe(u, F.mes))) < 0) return false;
        if (sin !== 'q' && F.q) {
            const t = F.q;
            if (String(u.id) !== t && (u.nombre + ' ' + u.dir + ' ' + D.hosts[u.host][1]).toLowerCase().indexOf(t) < 0) return false;
        }
        return true;
    }
    const filtrar = (F, sin) => A.filter((u) => pasa(u, F, sin));

    /** Cuenta por clave con todos los filtros salvo el propio. */
    function contarPor(F, sin, clave, n) {
        const r = new Array(n).fill(0);
        for (const u of A) if (pasa(u, F, sin)) r[clave(u)]++;
        return r;
    }
    function porMes(F) {
        const r = new Array(D.meses.length).fill(0);
        for (const u of A) if (pasa(u, F, 'mes')) for (let m = 0; m < r.length; m++) if (u.ent[m] > 0) r[m]++;
        return r;
    }
    function mediana(l) {
        if (!l.length) return null;
        const s = l.slice().sort((a, b) => a - b);
        const k = s.length >> 1;
        return s.length % 2 ? s[k] : Math.round((s[k - 1] + s[k]) / 2);
    }
    function preciosDe(lista, m) {
        const r = [];
        for (const u of lista) { const p = precioMes(u, m); if (p !== null && p >= 50) r.push(p); }
        return r;
    }
    const rango = (l) => {
        if (l.length < 4) return null;
        const s = l.slice().sort((a, b) => a - b);
        return [s[Math.floor(s.length * 0.25)], s[Math.floor(s.length * 0.75)]];
    };

    // ── Integraciones pendientes (CRM de prospectos) ─────────────────────
    const CRM = D.crm.map((x) => ({ id: x[0], empresa: x[1], ciudades: x[2], tipo: x[3], clave: x[4], estado: x[5], prio: x[6], desde: x[7], paises: x[8], slugs: x[9] }))
        .filter((c) => CRM_ABIERTO.indexOf(c.clave) >= 0);
    function crmDe(F) {
        return CRM.filter((c) => {
            if (F.pais) {
                if (c.paises.indexOf(F.pais) < 0) return false;
                if (F.ciudad >= 0) return c.slugs.indexOf(D.ciudades[F.ciudad][0]) >= 0;
                return true;
            }
            if (F.cont) return c.paises.some((p) => contDe(p) === F.cont);
            return true;
        });
    }

    // ── Demanda (users_intake) cruzada con la oferta ─────────────────────
    // Una solicitud está "cubierta" si en su ciudad, en su mes de llegada, hay
    // al menos una unidad disponible de un tipo compatible y con precio
    // ≤ presupuesto + 10 %. Tipo pedido: 0 habitación, 1 dpto 1D/monoambiente,
    // 2 dpto 2D; -1 indiferente.
    const DEM = D.demanda.map((x) => ({ ci: x[0], pais: paisDe(x[0]), cont: contDe(paisDe(x[0])), mes: x[1], cat: x[2], personas: x[3], pres: x[4], creado: x[5], inicio: x[6], estado: x[7] }));
    const compatibles = (catDem) => (catDem === 0 ? [0] : catDem === 1 ? [1, 2] : catDem === 2 ? [2] : [0, 1, 2]);
    function demanda(F) {
        const m = F.mes;
        const filas = DEM.filter((d) => (!F.cont || d.cont === F.cont) && (!F.pais || d.pais === F.pais) && (m < 0 || d.mes === m) && d.mes >= 0);
        // mínimo precio disponible por ciudad, mes y categoría
        const minimos = new Map();
        const clave = (ci, mm, c) => ci * 100 + mm * 10 + c;
        const ciudadesDem = new Set(filas.map((d) => d.ci));
        for (const u of A) {
            if (!ciudadesDem.has(u.ci)) continue;
            for (let mm = 0; mm < D.meses.length; mm++) {
                if (!(u.ent[mm] > 0)) continue;
                const p = precioMes(u, mm);
                const k = clave(u.ci, mm, u.cat);
                const ant = minimos.get(k);
                if (ant === undefined || (p !== null && (ant === null || p < ant))) minimos.set(k, p);
            }
        }
        const porCiudad = new Map();
        for (const d of filas) {
            let c = porCiudad.get(d.ci);
            if (!c) porCiudad.set(d.ci, (c = { ci: d.ci, total: 0, cubiertas: 0, motivoPrecio: 0, motivoTipo: 0, pres: [] }));
            c.total++;
            if (d.pres) c.pres.push(d.pres);
            let hayTipo = false;
            let cubierta = false;
            for (const cat of compatibles(d.cat)) {
                const k = clave(d.ci, d.mes, cat);
                if (!minimos.has(k)) continue;
                hayTipo = true;
                const p = minimos.get(k);
                if (!d.pres || p === null || p <= d.pres * 1.1) { cubierta = true; break; }
            }
            if (cubierta) c.cubiertas++;
            else if (hayTipo) c.motivoPrecio++;
            else c.motivoTipo++;
        }
        const lista = [...porCiudad.values()].map((c) => {
            const Fc = Object.assign({}, F, { ciudad: c.ci, cat: [], tramo: [], grupo: [], est: [], q: '' });
            if (!Fc.pais) Fc.pais = paisDe(c.ci);
            const disp = F.mes < 0 ? filtrar(Object.assign(Fc, { mes: 0 })).length : filtrar(Fc).length;
            const sin = c.total - c.cubiertas;
            let senal = 'equilibrado';
            if (sin >= 5 && sin / c.total > 0.5) senal = 'captar';
            else if (disp >= c.total * 20 && c.total > 0) senal = 'campanas';
            return Object.assign(c, { disp, sin, presMed: mediana(c.pres), senal });
        });
        lista.sort((a, b) => b.total - a.total);
        return { filas, lista };
    }
    // Ciudades con mucha oferta y poca demanda (para "dirigir campañas")
    function demandaPorPais(cont) {
        const r = {};
        for (const d of DEM) if (d.mes >= 0 && (!cont || d.cont === cont)) r[d.pais] = (r[d.pais] || 0) + 1;
        return r;
    }

    // ── Cierres (reservas aceptadas y pagadas): cuánto se quedan de verdad ─
    const CIE = (D.cierres || []).map((x) => ({ ci: x[0], pais: paisDe(x[0]), cont: contDe(paisDe(x[0])), dias: x[1], mes: x[2], cat: x[3], inicio: x[4] }));
    /** Estadía de los cierres en el ámbito de F; si hay menos de 5, usa el ámbito más amplio. */
    function cierres(F) {
        const ambitos = [];
        if (F.pais && F.ciudad >= 0) ambitos.push(['ciudad', (c) => c.ci === F.ciudad, D.ciudades[F.ciudad][1]]);
        if (F.pais) ambitos.push(['pais', (c) => c.pais === F.pais, D.paises[F.pais] ? D.paises[F.pais].n : F.pais]);
        if (F.cont) ambitos.push(['cont', (c) => c.cont === F.cont, CONT[F.cont] ? CONT[F.cont].n : '']);
        ambitos.push(['todo', () => true, 'todo House & Flats']);
        let usado = ambitos[ambitos.length - 1];
        let lista = CIE;
        for (const a of ambitos) { const l = CIE.filter(a[1]); if (l.length >= 5) { usado = a; lista = l; break; } }
        // Más de 2 años son casos raros (contratos de 36 y 40 meses): no entran al promedio
        const dias = lista.map((c) => c.dias).filter((d) => d > 0 && d <= 730);
        const prom = dias.length ? Math.round(dias.reduce((a, b) => a + b, 0) / dias.length) : null;
        const med = mediana(dias);
        const tramos = new Array(ESTADIA.length + 1).fill(0); // + "menos de 1 mes"
        dias.forEach((d) => { const i = estadiaDe(d); tramos[i < 0 ? ESTADIA.length : i]++; });
        return { n: lista.length, usados: dias.length, prom, med, tramos, ambito: usado[0], ambitoN: usado[2], propio: usado === ambitos[0] };
    }

    // ── Formato ──────────────────────────────────────────────────────────
    const nf = new Intl.NumberFormat('es-ES');
    const num = (n) => (n === null || n === undefined ? '–' : nf.format(n));
    const eur = (n) => (n === null || n === undefined ? '–' : nf.format(Math.round(n)) + ' €');
    const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);
    const MESES_C = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function fechaEntrada(m, diaMes) {
        const [a, mm] = D.meses[m].k.split('-').map(Number);
        return diaMes + ' ' + MESES_C[mm - 1] + (a !== new Date().getFullYear() ? ' ' + String(a).slice(2) : '');
    }
    const esc = (t) => String(t === null || t === undefined ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const capital = (t) => t.charAt(0).toUpperCase() + t.slice(1);
    const bandera = (p) => (p && p !== 'XX' ? 'https://flagcdn.com/' + p.toLowerCase() + '.svg' : '');

    function paisesDe(cont) {
        const r = {};
        for (const u of A) if (u.cont === cont) r[u.pais] = (r[u.pais] || 0) + 1;
        return Object.keys(r).sort((a, b) => r[b] - r[a]).map((p) => ({ p, n: r[p] }));
    }
    function ciudadesDe(pais) {
        const r = {};
        for (const u of A) if (u.pais === pais) r[u.ci] = (r[u.ci] || 0) + 1;
        return Object.keys(r).map(Number).sort((a, b) => {
            const oa = D.ciudades[a][0] === 'otras';
            const ob = D.ciudades[b][0] === 'otras';
            return oa !== ob ? (oa ? 1 : -1) : r[b] - r[a];
        }).map((ci) => ({ ci, n: r[ci] }));
    }

    return {
        D, A, CRM, DEM, CIE, CAT, SUB, TRAMOS, INTEG, CONT, ESTADIA, BASE,
        libreDe, estadiaDe, mesesTxt, cierres, primerMesDisp,
        precioMes, tramoDe, disponible, pasa, filtrar, contarPor, porMes, mediana, preciosDe, rango,
        crmDe, demanda, demandaPorPais, paisesDe, ciudadesDe, contDe,
        num, eur, pct, fechaEntrada, esc, capital, bandera,
    };
}
